import { FEMALE, KIDS, MALE } from 'constants/gender'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { useRouter } from 'helpers/navigation'
import { translateGender } from 'helpers/translateGender'
import React from 'react'
import { useUrlManagerStore, useUserStore } from 'store/context'
import styled, { css } from 'styled-components'
import ActionButton from 'uiComponents/atoms/Buttons/ActionButton'
import { darkGrayColor } from 'uiComponents/constants/colors'

const StyledActionButton = styled(ActionButton)<{ noBorder: boolean }>`
  margin-right: 5px;
  ${({ noBorder }) =>
    noBorder &&
    css`
      color: ${darkGrayColor};
      border-color: transparent;
    `};
`

interface IProps {
  className?: string
}

const GenderSwitch: React.FC<IProps> = ({ className }) => {
  const urlMangerStore = useUrlManagerStore()
  const { gender } = useUserStore()
  const { t } = useTranslation()
  const { navigateClient } = useRouter()
  const { pathname } = urlMangerStore

  return (
    <span className={className}>
      <StyledActionButton
        title={translateGender(t, 'female')}
        noBorder={gender !== FEMALE}
        onClick={navigateClient(`${pathname}?gender=female`)}
      />
      <StyledActionButton
        title={translateGender(t, 'male')}
        noBorder={gender !== MALE}
        onClick={navigateClient(`${pathname}?gender=male`)}
      />
      <StyledActionButton
        title={translateGender(t, 'kids')}
        noBorder={gender !== KIDS}
        onClick={navigateClient(`${pathname}?gender=kids`)}
      />
    </span>
  )
}

export default GenderSwitch
